<template>
  <section class="bg-white pt-4 xl:pb-24">
    <div class="container px-4  mx-auto">
      <div class="flex flex-wrap  items-center">
        <div class="inline-block max-w-xl mb-6 md:mb-0">
          <h4 class="md:text-2xl text-green-500">
            Do you need a Trial or Demo?
          </h4>
          <p class="text-xl text-gray-500">
            Drop us a message. We'll review your request and see how can we help each other.
          </p>
        </div>
        <a
          class="inline-block ml-auto w-full  rounded-md shadow-sm md:w-auto px-12 py-4 text-center text-sm text-white font-medium leading-normal bg-green-500 hover:bg-green-600 focus:ring-2 focus:ring-green-500 focus:ring-opacity-50"
          href="https://www.zimmerpeacocktech.com/contact-support/"
          target="_blank"
        >Contact</a>
      </div>
    </div>
    <div class="pt-8">
      <div class="container mx-auto">
        <span class="inline-block py-px px-2 mb-4 text-xs leading-5 text-green-500 bg-green-100 font-medium uppercase rounded-9xl">Pricing</span>
        <h3 class="mb-4 text-3xl md:text-5xl text-coolGray-900 font-bold tracking-tighter">
          Flexible pricing for your electrochemical sensor data needs.
        </h3>
        <p class="mb-12 text-lg md:text-xl text-coolGray-500 font-medium">
          Pricing that scales with your research rapidly.
          <b-button
            class="bg-green-500"
            variant="primary"
            @click="toggleCollapse"
          >
            <b-icon :icon="isOpen ? 'caret-up-fill' : 'caret-down-fill'" />{{ isOpen ? 'Hide Subscription Types' : 'See Subscription Types' }}
          </b-button>
        </p>
        <b-collapse
          v-model="isOpen"
          class="mt-2"
          @collapsed="onCollapsed"
          @expanded="onExpanded"
        >
          <div class="col-sm-12 col-md-8 mx-auto">
            <b-card class="p-0">
              <b-card-header class="d-flex align-items-center pt-3 bg-green-500">
                <b-card-title class="h5 mb-0 mx-auto">
                  <span class="text-white text-center">DJULI-FREEMIUM VERSUS PREMIUM SUBSCRIPTIONS</span>
                </b-card-title>
              </b-card-header>
              <b-card-body class="text-justify p-1">
                <b-table
                  responsive
                  bordered
                  small
                  :items="items"
                  :fields="fields"
                  :tbody-tr-class="rowClass"
                />
              </b-card-body>
            </b-card>
          </div>
        </b-collapse>
        <div class="flex flex-wrap justify-center -mx-4">
          <div class="w-full md:w-1/2 lg:w-1/3 p-4">
            <div class="flex flex-col items-center pt-10 px-8 pb-8 bg-coolGray-50 rounded-md shadow-md hover:scale-105 transition duration-500">
              <span class="inline-block py-px px-2 mb-6 text-xs leading-5 text-green-500 bg-green-100 font-medium uppercase rounded-9xl">Pricing</span>
              <h3 class="mb-4 text-lg md:text-2xl text-green-500 font-medium">
                Start
              </h3>
              <div class="mb-4">
                <span class="relative -top-6 right-1 text-3xl text-coolGray-900 font-medium">Free</span>
                <span class="text-5xl text-coolGray-900 font-medium" />
              </div>
              <div class="mb-7 text-lg md:text-xl text-coolGray-400 font-medium">
                <p>No Credit Card needed</p>
              </div>
              <ul class="self-start mb-8">
                <li
                  class="flex items-center mb-3 text-coolGray-500 font-medium"
                >
                  <img
                    class="mr-3"
                    src="../../assets/Images/checkbox-green.png"
                  >
                  <span>Complete documentation</span>
                </li>
                <li
                  class="flex items-center mb-3 text-coolGray-500 font-medium"
                >
                  <img
                    class="mr-3"
                    src="../../assets/Images/checkbox-green.png"
                  >
                  <span>Real time data analysis</span>
                </li>
                <li
                  class="flex items-center mb-3 text-coolGray-500 font-medium"
                >
                  <img
                    class="mr-3"
                    src="../../assets/Images/checkbox-green.png"
                  >
                  <span>Unlimited cloud storage</span>
                </li>
                <li class="flex items-center text-coolGray-500 font-medium">
                  <img
                    class="mr-3"
                    src="../../assets/Images/checkbox-green.png"
                  >
                  <span>Limited access to features</span>
                </li>
              </ul>
              <button
                class="inline-block py-3 px-7 w-full text-green-50 font-medium text-center bg-green-500 hover:bg-green-600 focus:ring-2 focus:ring-green-500 focus:ring-opacity-50 rounded-md shadow-sm"
                @click="$router.push('/register/freemium')"
              >
                Subscribe to Freemium
              </button>
            </div>
          </div>
          <div
            v-for="plan in subscrtionplans"
            :key="plan.metadata.name"
            class="w-full md:w-1/2 lg:w-1/3 p-4"
          >
            <div class="flex flex-col items-center pt-10 px-8 pb-8 bg-white rounded-md shadow-md hover:scale-105 transition duration-500">
              <span class="inline-block py-px px-2 mb-6 text-xs leading-5 text-green-500 bg-green-100 font-medium uppercase rounded-9xl">Pricing</span>
              <h3 class="mb-4 text-lg md:text-xl text-green-500 font-medium">
                {{ plan.metadata.name }}
              </h3>
              <div class="mb-4">
                <span class="relative -top-6 right-1 text-2xl text-coolGray-900 font-medium">€</span>
                <span class="text-5xl text-coolGray-900 font-medium">{{ plan.amount/100 }}</span>
                <span
                  v-if="plan.metadata.name.split(' ')[0]==='Monthly'"
                  class="text-3xl text-coolGray-900 font-medium"
                >/mo</span>
                <span
                  v-if="plan.metadata.name.split(' ')[0]==='Half'"
                  class="text-3xl text-coolGray-900 font-medium"
                >/hy</span>
                <span
                  v-if="plan.metadata.name.split(' ')[0]==='Yearly'"
                  class="text-3xl text-coolGray-900 font-medium"
                >/yr</span>
              </div>
              <div class="mb-7 text-lg md:text-xl text-coolGray-400 font-medium">
                <p v-if="plan.metadata.name.split(' ')[0]==='Monthly'">
                  Billed Monthly
                </p>
                <p v-if="plan.metadata.name.split(' ')[0]==='Half'">
                  Billed Half Yearly
                </p>
                <p v-if="plan.metadata.name.split(' ')[0]==='Yearly'">
                  Billed Yearly
                </p>
              </div>
              <ul class="self-start mb-8">
                <li class="flex items-center mb-3 text-coolGray-500 font-medium">
                  <img
                    class="mr-3"
                    src="../../assets/Images/checkbox-green.png"
                  >
                  <span>Complete documentation</span>
                </li>
                <li class="flex items-center mb-3 text-coolGray-500 font-medium">
                  <img
                    class="mr-3"
                    src="../../assets/Images/checkbox-green.png"
                  >
                  <span>Real time data analysis</span>
                </li>
                <li class="flex items-center mb-3 text-coolGray-500 font-medium">
                  <img
                    class="mr-3"
                    src="../../assets/Images/checkbox-green.png"
                  >
                  <span>Unlimited cloud storage</span>
                </li>
                <li class="flex items-center text-coolGray-500 font-medium">
                  <img
                    class="mr-3"
                    src="../../assets/Images/checkbox-green.png"
                  >
                  <span>Share data between users</span>
                </li>
              </ul>
              <button
                class="inline-block py-3 px-7 w-full text-green-50 font-medium text-center bg-green-500 hover:bg-green-600 focus:ring-2 focus:ring-green-500 focus:ring-opacity-50 rounded-md shadow-sm"
                @click="collectPlan(plan)"
              >
                Select plan
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import Vuex from 'vuex';
export default {
	metaInfo: {
		title: 'Pricing – Djuli',
		meta: [
			{ name: 'description', content: 'Flexible pricing plans for sensor data analysis. Start free, scale as your research grows.' },
			{ property: 'og:title', content: 'Pricing – Djuli' },
			{ property: 'og:url', content: 'https://dju.li/pricing' },
			{ property: 'og:type', content: 'website' },
		],
	},
	mounted() {
		document.dispatchEvent(new Event('render-event'));
	},
	data() {
      return {
				showPriceSummary: false,
				isOpen: false,
				anchorValue:'Click here',
        fields: [{key:'feature',label:'Feature', class: 'bg-coolGray-50'}, {key:'freemium', label:'Freemium'}, {key:'premium', label:'Full access-Premium'}],
        items: [
          { feature: 'Price', freemium: 'Free', premium: '99€ per month' },
          { feature: 'No. of Reports', freemium: '5 + 3 examples', premium: 'Unlimited' },
          { feature: 'Tools', freemium: '✓', premium: '✓' },
					{ feature: 'Export Reports', freemium: '✓', premium: '✓' },
					{ feature: 'Template', freemium: ' ', premium: '✓' },
					{ feature: 'Continuous studies', freemium: '✓', premium: '✓' },
					{ feature: 'Discrete studies', freemium: '✓', premium: '✓' },
					{ feature: 'Amperometric analysis', freemium: '✓', premium: '✓' },
					{ feature: 'Potentiometric analysis', freemium: '✓', premium: '✓' },
					{ feature: 'Voltammetric analysis', freemium: '✓', premium: '✓' },
					{ feature: 'Impedimetric analysis', freemium: '✓', premium: '✓' },
					{ feature: 'Generic analysis', freemium: '✓', premium: '✓' },
					{ feature: 'Download raw data', freemium: ' ', premium: '✓' },
					{ feature: 'Download analysis results', freemium: '✓', premium: '✓' },
					{ feature: 'Delete report', freemium: ' ', premium: '✓' },
					{ feature: 'Edit a report - save changes', freemium: ' ', premium: '✓' },
					{ feature: 'Create a cluster', freemium: ' ', premium: '✓' },
					{ feature: 'Comparative reports', freemium: '✓', premium: '✓' },
					{ feature: 'IoT compatibility', freemium: ' ', premium: '✓' },
					{ feature: 'API access', freemium: '✓', premium: '✓' }
        ]
      }
    },
  computed:{
    ...Vuex.mapGetters({subscrtionplans:'subscription/listSubscriptionPlans',isAuthenticatedMiddlewareAuth:'isAuthenticatedMiddlewareAuth'})
  },
   async created(){
    let fetch_plan_status=  await this.fetchAllPlanDetails()
    if(!fetch_plan_status){
      await this.$alert(
        'Error fetching plans information. Please try again in few seconds.',
        'Error',
        'error',
      )
    }
  },
  methods:{
    ...Vuex.mapActions({fetchAllPlanDetails:'subscription/listAllPlans',showSelectedPlan:'subscription/userBasedPlanDetails'}),
    async collectPlan(plan){
      if(!this.isAuthenticatedMiddlewareAuth){
        const formattedName = plan.metadata.name.replace(' ', '-').toLowerCase()
        this.$router.push(`/register/${formattedName}`);
      }else{
        let selected_plan_payload={
          product_id:plan.product,
          plan_type:plan.metadata.name
        }
       let status= await this.showSelectedPlan(selected_plan_payload)
       if(!status){
         await this.$alert(
          'Error while select the plan. Please try again in few seconds.',
          'Error',
          'error',
        )
        return
       }
        this.$router.push('/choosenplan');
      }
    },
		rowClass(item, type) {
        if (!item || type !== 'row') return
        if (item.status === 'awesome') return 'table-success'
    },
		onCollapsed() {
      this.anchorValue = 'Click here';
    },
    onExpanded() {
      this.anchorValue = 'Hide price summary';
    },
		toggleCollapse() {
      this.isOpen = !this.isOpen;
    },
  }


}
</script>
<style scoped>
ul{
    text-align: center;
    justify-content: center;
    display: flex;
    margin: auto;
    flex-direction: column;
    padding-bottom: 2rem;
}
.text-green {
  color: green;
}

a:hover {
  cursor: pointer !important;
}
.custom-table thead th {
  background-color: green;
  color: white;
}
.b-table td {
  padding: 0.2rem 0.5rem !important; /* Adjust the padding to reduce cell height */
}

@media (max-width: 768px) {
  .b-table td {
    font-size: 1.5vw !important; /* Use 'vw' for responsive font size */
  }
}
</style>